import React, {useState} from 'react';
import {Dropdown} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faFileCsv, faFileExcel, faFileExport} from '@fortawesome/free-solid-svg-icons';
import Utils from '../services/Utils';

const FORMATS = [
  {format: 'xlsx', label: 'Excel (.xlsx)', icon: faFileExcel, className: 'text-success'},
  {format: 'csv', label: 'CSV (.csv)', icon: faFileCsv, className: 'text-info'},
];

// Bouton « Exporter » des pages Réservations et Clients : menu CSV / Excel, téléchargement du fichier
// renvoyé par `request(format)` (appel API en blob) sous le nom `${filename}_AAAA-MM-JJ.${format}`.
// À placer directement dans une .ccv2-toolbar (styles mobiles du menu dans _ccv2-buttons.scss).
export default ({intl, request, filename, disabled}) => {
  const [busy, setBusy] = useState(false);

  const handleExport = (format) => {
    setBusy(true);
    request(format).then(response => {
      setBusy(false);
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}_${new Date().toISOString().slice(0, 10)}.${format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  };

  return (
    <Dropdown>
      <Dropdown.Toggle as="button" type="button" className="ccv2-btn ccv2-btn-secondary" disabled={disabled || busy}>
        <FontAwesomeIcon icon={faFileExport}/> <FormattedMessage id="EXPORT"/>
        <FontAwesomeIcon icon={faChevronDown} className="ms-1"/>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dashboard-dropdown custom-export-dropdown mt-1">
        {FORMATS.map(f => (
          <Dropdown.Item key={f.format} onSelect={() => handleExport(f.format)}>
            <FontAwesomeIcon icon={f.icon} className={`${f.className} me-2`}/> {f.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
